<template>
  <div>
    <div id="exploration" class="exploration-modal">
      <div class="exploration-header">
        <div class="exploration-title">Related</div>

        <div id="indicator" v-if="this.related_number > 1">
          <div
            v-for="related in this.related_number"
            :key="related"
            class="dot"
          ></div>
        </div>

        <img
          @click="changeExplorationState()"
          id="exploration-close-button"
          src="../assets/close_button.png"
          alt="close exploration pop-up"
        />
      </div>

      <div class="full hide-scroll">
        <div class="chunk-slideshow">
          <div
            v-for="image in this.imageObject[this.playbackIndex]"
            :key="image['resource_id']"
            class="chunk-alternative"
          >
            <img class="image-container" :src="image['url']" alt="" />
          </div>

          <div
            v-if="
              this.entityObject[this.playbackIndex] != undefined &&
              this.entityObject[this.playbackIndex] != 0
            "
            class="chunk-alternative"
          >
            <EntityCard :entity="this.entityObject[this.playbackIndex]" />
          </div>

          <div
            v-for="url in this.urlpreviewObject[this.playbackIndex]"
            :key="url['url']"
            class="chunk-alternative"
          >
            <UrlPreviewCard
              :title="url['title']"
              :description="url['description']"
              :url="url['url']"
              :image="url['image']"
            />
          </div>

          <div
            class="chunk-alternative"
            v-for="(similar, index) in this.similarityObject[
              this.playbackIndex
            ]"
            :key="index"
            :id="index"
          >
            <ChunkCard
              :chunk_text="similar['text']"
              :speaker="
                matched_entities[sourceToSpeaker(similar['source_file'])]
              "
              :collection_id="similar['collection_id']"
              :chunk_id="similar['source_file']"
            />
          </div>
        </div>
      </div>
    </div>
    <DeepDive v-show="deepDiveVisible" />
  </div>
</template>

<script>
import DeepDive from "./DeepDive.vue";
import ChunkCard from "../components/ChunkCard.vue";
import EntityCard from "../components/EntityCard.vue";
import UrlPreviewCard from "../components/UrlPreviewCard.vue";
import { mapState } from "vuex";
import config from "../data/ecchr_config.json";

export default {
  name: "Exploration",
  components: {
    DeepDive,
    ChunkCard,
    EntityCard,
    UrlPreviewCard,
  },
  data() {
    return {
      related_number: 0,
      matched_entities: config["matched_entities"][0],
    };
  },
  computed: {
    ...mapState([
      "device_mode",
      "explorationVisible",
      "deepDiveVisible",
      "entityObject",
      "imageObject",
      "similarityObject",
      "urlpreviewObject",
      "playbackIndex",
    ]),
  },
  updated() {
    this.$nextTick(function () {
      let alternatives = document.querySelectorAll(".chunk-alternative");
      this.related_number = alternatives.length;
      const options = this.setSimilarSelectArea();

      this.observer = new IntersectionObserver(([entry]) => {
        if (this.related_number > 1) {
          let dot = document.getElementById("indicator");
          const element = entry.target;
          let child_dot_index = Array.from(element.parentNode.children).indexOf(
            element
          );

          let child_dot = dot.childNodes[child_dot_index];
          if (entry && entry.isIntersecting) {
            child_dot.classList.add("dot-active");
          } else {
            child_dot.classList.remove("dot-active");
          }
        }
      }, options);

      alternatives.forEach((chunk_similar_viewport) => {
        this.observer.observe(chunk_similar_viewport);
      });

      let slideshow = document.querySelector(".chunk-slideshow");
      slideshow.style.setProperty("--box-number", alternatives.length);
    });
  },
  watch: {
    device_mode: function (device_mode) {
      const playerContainer = document.getElementById("exploration");
      if (device_mode == "mobile") {
        playerContainer.style.width = "100%";
        playerContainer.style.height = "90vh";
        playerContainer.classList.remove("exploration-desktop");
        playerContainer.classList.add("exploration-mobile");
      } else {
        playerContainer.style.width = "375px";
        playerContainer.style.height = "593px";
        playerContainer.classList.remove("exploration-mobile");
        playerContainer.classList.add("exploration-desktop");
      }
    },
  },
  mounted() {
    const explorationContainer = document.getElementById("exploration");
    if (this.device_mode == "mobile") {
      explorationContainer.style.width = "100%";
      explorationContainer.style.height = "90vh";
      explorationContainer.classList.remove("exploration-desktop");
      explorationContainer.classList.add("exploration-mobile");
    } else {
      explorationContainer.style.width = "375px";
      explorationContainer.style.height = "593px";
      explorationContainer.classList.remove("exploration-mobile");
      explorationContainer.classList.add("exploration-desktop");
    }
  },
  methods: {
    sourceToSpeaker(source) {
      if (source != 0) {
        let speaker = source.split("-");
        speaker = speaker[1];
        speaker = speaker.replace(".mp3", "");
        return speaker;
      }
    },
    changeDeepDiveState() {
      this.$store.commit("toggleDeepDive");
    },
    changeExplorationState() {
      this.$store.commit("toggleExploration");
    },
    setSimilarSelectArea() {
      const options = {
        root: null,
        threshold: 0.9,
      };
      return options;
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

.exploration-modal {
  --gutter: 20px;
  grid-gap: var(--gutter) 0;
  grid-template-columns: var(--gutter) 1fr var(--gutter);
  align-content: start;
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
  .exploration-modal {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background-color: rgba(44, 44, 46, 0.3);
    z-index: 1;
  }
  .warning {
    display: none;
  }
}

.exploration-mobile {
  position: fixed;
  top: 0px;
}

.chunk-slideshow:after > * {
  grid-column: 2 / -2;
}

.exploration-modal > .full {
  grid-column: 1 / -1;
}

.chunk-slideshow {
  --gutter: 20px;
  display: grid;
  grid-gap: 20px;
  grid-template-columns:
    10px repeat(var(--box-number), calc(90% - var(--gutter) * 2))
    10px;
  grid-template-rows: minmax(150px, 1fr);

  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  padding-top: 30px;
  padding-bottom: calc(0.75 * var(--gutter));
  margin-bottom: calc(-0.5 * var(--gutter));
}

.chunk-slideshow:before,
.chunk-slideshow:after {
  content: "";
}

.chunk-slideshow > .chunk-alternative {
  color: black;
  --gutter: 20px;
  scroll-snap-align: center;
  border-radius: 8px;
}

.exploration-header {
  display: grid;
  grid-template-areas: "exploration-title dots close";
  grid-template-columns: 0.25fr 0.5fr 0.25fr;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(72, 72, 74, 1);
}

.exploration-title {
  grid-area: exploration-title;
  place-self: center;
  font-size: 16px;
  font-weight: 700;
}

.dot {
  cursor: pointer;
  height: 8px;
  width: 8px;
  margin: 0 2px;
  background-color: rgb(116, 116, 116);
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.dot-active {
  background-color: rgb(203, 203, 203);
}

#exploration-close-button {
  grid-area: close;
  justify-self: flex-end;
  align-self: center;
  margin-right: 10px;
  width: 32px;
}

#exploration-close-button:hover {
  cursor: pointer;
}

#indicator {
  grid-area: dots;
  place-self: center;
}

.chunk-card-exploration {
  margin: none;
}

/* img {
  width: 32px;
} */

.image-container {
  min-width: 100%;
  max-width: 100%;
  border-radius: 8px;
}
</style>